import { render, staticRenderFns } from "./create-task-modal.vue?vue&type=template&id=24087bb9&"
import script from "./create-task-modal.vue?vue&type=script&lang=ts&"
export * from "./create-task-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports